import {
  searchContextMetadata,
  type SearchContextMetadata
} from '../model/global-search-context-metadata'

/**
 * The context registry (title/description/prefix/icon per context),
 * exposed through a composable per the MVVM internal-import rule —
 * components must not value-import from `model/` directly.
 */
export function useGlobalSearchContextMetadata() {
  return searchContextMetadata
}

export type { SearchContextMetadata }
